import React from 'react';
import { Award, Crown } from 'lucide-react';
import { trainers } from '../data/mock';

export default function Trainers() {
  const founder = trainers.find((t) => t.isFounder);
  const others = trainers.filter((t) => !t.isFounder);

  return (
    <section id="trainers" className="relative py-20 md:py-32 overflow-hidden" style={{ background: 'linear-gradient(180deg, #0a1428 0%, #08111f 100%)' }}>
      <div className="absolute top-1/3 -left-32 w-72 h-72 md:w-96 md:h-96 bg-blue-600/10 blur-[120px] rounded-full pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="mb-14">
          <p className="section-eyebrow text-amber-400">04 — Our Trainers</p>
          <h2 className="mt-4 font-anton text-3xl sm:text-4xl md:text-6xl leading-[0.95] text-white">
            COACHED BY <span className="text-blue-500">THE BEST</span>
          </h2>
        </div>

        {/* Founder card - Kiron with NIFS poster */}
        {founder && (
          <div className="grid lg:grid-cols-5 gap-6 lg:gap-8 rounded-3xl bg-white/[0.03] border border-white/10 p-4 md:p-6 mb-10">
            <div className="lg:col-span-3 relative rounded-2xl overflow-hidden bg-black">
              <img
                src={founder.poster}
                alt={founder.name}
                className="w-full h-auto object-contain max-h-[640px]"
              />
            </div>
            <div className="lg:col-span-2 p-2 md:p-6 flex flex-col justify-center">
              <span className="inline-flex items-center gap-2 self-start bg-amber-500 text-slate-950 text-xs font-bold px-3 py-1.5 rounded-full">
                <Crown className="w-3.5 h-3.5" />
                {founder.role}
              </span>
              <h3 className="mt-4 font-anton text-white text-4xl sm:text-5xl md:text-6xl">{founder.name}</h3>
              <p className="mt-3 inline-flex items-center gap-2 text-blue-400 font-medium text-sm md:text-base">
                <Award className="w-4 h-4" />
                {founder.experience}
              </p>
              <p className="mt-4 text-white/70 leading-relaxed text-sm md:text-base">{founder.bio}</p>
              <p className="mt-4 text-[11px] md:text-xs text-amber-400 font-semibold tracking-wider">CERTIFIED · NIFS TRAINER & OWNER</p>
            </div>
          </div>
        )}

        {/* Other trainers */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {others.map((t, i) => {
            const hasPoster = !!t.poster;
            return (
              <div
                key={t.name}
                className="group relative rounded-2xl overflow-hidden bg-white/[0.03] border border-white/10 hover:border-blue-500/40 transition-all duration-300 hover:-translate-y-1 fade-up"
                style={{ animationDelay: `${i * 80}ms` }}
              >
                {hasPoster ? (
                  // Branded poster - show full poster, then info below
                  <>
                    <div className="relative bg-black overflow-hidden">
                      <img
                        src={t.poster}
                        alt={t.name}
                        className="w-full h-auto object-contain group-hover:scale-[1.02] transition-transform duration-500"
                      />
                    </div>
                    <div className="p-5 border-t border-white/10">
                      <div className="flex items-center justify-between gap-2 mb-2">
                        <h4 className="font-anton text-white text-2xl">{t.name}</h4>
                        <span className="inline-block text-[10px] font-bold px-2 py-1 rounded bg-amber-500 text-slate-950">
                          {t.role.toUpperCase()}
                        </span>
                      </div>
                      <p className="inline-flex items-center gap-2 text-blue-400 text-sm font-medium">
                        <Award className="w-3.5 h-3.5" />
                        {t.experience}
                      </p>
                      <p className="mt-1 text-white/60 text-sm">{t.specialty}</p>
                    </div>
                  </>
                ) : (
                  // Simple portrait style (Poulomi Bag)
                  <div className="relative aspect-[4/5] overflow-hidden">
                    <img src={t.image} alt={t.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent" />
                    <div className="absolute top-4 left-4">
                      <span className="inline-block text-xs font-bold px-2.5 py-1 rounded bg-amber-500 text-slate-950">
                        {t.role}
                      </span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-5">
                      <h4 className="font-anton text-white text-2xl md:text-3xl">{t.name}</h4>
                      <p className="mt-1 inline-flex items-center gap-2 text-blue-400 text-sm font-medium">
                        <Award className="w-3.5 h-3.5" />
                        {t.experience}
                      </p>
                      <p className="mt-1 text-white/70 text-sm">{t.specialty}</p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
